<template>
  <v-list-tile @click="open">
    <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'plus']"></font-awesome-icon></v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-title>ビザ取得歴を追加する</v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action class="text-xs-right">
      <v-btn flat :disabled="true"></v-btn>
    </v-list-tile-action>
    <v-dialog v-model="config.status.active" max-width="600" scrollable>
      <v-card>
        <v-card-title class="grey lighten-3 blue-grey--text text--darken-4">
          <span class="headline">過去に取得したビザを追加</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md class="pa-0">
            <v-form ref="form" v-model="form.valid" lazy-validation>
              <v-layout wrap>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.country"
                    label="発行国"
                    item-text="label"
                    item-value="code"
                    :rules="rules.country"
                    :items="getNationItems"></v-select>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-select
                    v-model="form.type"
                    label="ビザの種類"
                    item-text="text"
                    item-value="value"
                    :rules="rules.country"
                    :items="getTypeItems"></v-select>
                </v-flex>
                <v-flex xs12 class="px-3">
                  <v-menu lazy offset-y full-width
                    v-model="config.datepicker.publish"
                    transition="scale-transition"
                    min-width="290px"
                    :close-on-content-click="false">
                    <v-text-field readonly required
                      v-model="printFormatedPublish"
                      :rules="rules.publish"
                      slot="activator"
                      label="発行日"></v-text-field>
                    <v-date-picker
                      v-model="form.publish"
                      color="amber"
                      locale="ja"
                      :day-format="date => new Date(date).getUTCDate()"
                      @input="config.datepicker.publish = false"></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="grey lighten-3">
          <v-btn flat
            color="blue darken-2"
            @click="close">閉じる</v-btn>
          <v-spacer></v-spacer>
          <v-btn depressed color="blue darken-2" class="white--text"
            :disabled="!isValid"
            :loading="isLoading"
            @click="submit">追加する</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-list-tile>
</template>

<script>
export default {
  name: 'insert-modal',
  data () {
    return {
      config: {
        status: {
          active: false,
          loading: false,
          searching: false
        },
        datepicker: {
          publish: false
        }
      },
      rules: {
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        publish: [
          v => !!v || '必須項目です'
        ]
      },
      form: {
        valid: true,
        status: 'DONE',
        country: '',
        type: '',
        publish: ''
      }
    }
  },
  methods: {
    init: function () {
      this.$set(this, 'form', {
        valid: true,
        status: 'DONE',
        country: '',
        type: '',
        publish: ''
      })
    },
    open: function () {
      this.init()
      this.$set(this.config.status, 'active', true)
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    },
    submit: function () {
      if (this.$refs.form.validate()) {
        this.$set(this.config.status, 'loading', true)
        this.axios.post(this.$url.api + 'user/about/insert/meta', {
          mtype: 'about.visa',
          form: {
            status: this.form.status,
            country: this.form.country,
            type: this.form.type,
            publish: this.form.publish
          }
        }, {
          headers: {
            'user-token': this.$localStorage.get('jwt')
          }
        }).then(res => {
          console.log(res)
          if (res.data && res.data.success) {
            this.$emit('emit', {
              action: 'insert',
              data: {
                type: 'visas',
                resolve: res.data.data
              }
            })
          }
          this.$set(this.config.status, 'loading', false)
          this.$set(this.config.status, 'active', false)
        })
      }
    }
  },
  computed: {
    isValid () {
      return this.form.valid
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    printFormatedPublish () {
      return (
        this.form &&
        this.form.publish
      ) ? this.$dateformat(this.form.publish, 'yyyy/mm/dd', true) : ''
    },
    getStatusItems () {
      return this.$meta.visa.status
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).map(key => {
        return {
          code: key,
          label: this.$meta.nations[key]
        }
      })
    },
    getTypeItems () {
      return Object.keys(this.$meta.visa.types).map(key => {
        return {
          value: key,
          text: this.$meta.visa.types[key]
        }
      })
    }
  }
}
</script>
